import { render } from "./AddEditCompetitorSlideOver.vue?vue&type=template&id=408d4fc8"
import script from "./AddEditCompetitorSlideOver.vue?vue&type=script&lang=ts"
export * from "./AddEditCompetitorSlideOver.vue?vue&type=script&lang=ts"
script.render = render

export default script